import { BaseError } from '@dynamic-labs-sdk/client';

export class NotBitcoinProviderError extends BaseError {
  public readonly providerKey: string;

  constructor(params: { providerKey: string }) {
    super({
      cause: null,
      code: 'not_bitcoin_provider_error',
      docsUrl: null,
      name: 'NotBitcoinProviderError',
      shortMessage: 'Provider is not a Bitcoin wallet provider',
    });

    this.providerKey = params.providerKey;
  }
}
